// extracted by mini-css-extract-plugin
export default {"purpleColor":"#358fb0","mainContentWrapper":"MainPage_mainContentWrapper__vPMUN","mainPageWrapper":"MainPage_mainPageWrapper__qsNY2"};